module.exports = require("@leeoniya/ufuzzy");